import React from 'react'

const ColumnItem = ({className, children}) => {
  return (
    <div className={`flex flex-col md:gap-y-5 gap-y-small w-full ${className || ''}`}>{children}</div>
  )
}

export default ColumnItem